export interface GuestRatingSquareProps {
    title: string;
    guestRating?: number;
}

const twoDigits = (value: number) => (value >= 10 ? Math.round(value) : (Math.round(value * 10) / 10).toFixed(1));

export const GuestRatingSquare = ({ title, guestRating }: GuestRatingSquareProps) => {
    const guestRatingShort = guestRating > 0 ? twoDigits(guestRating) : '';
    const guestRatingReadable =
        guestRating > 0 ? `Gjestevurdering av ${title.toLowerCase()}: ${guestRating} av 10` : 'Ingen gjestevurderinger';
    return (
        <div
            data-testid="guestRating"
            className="rating-square u-pa4 u-text-center u-t5 u-primary-blue u-border-radius-4px u-border-primary-blue"
            aria-label={guestRatingReadable}>
            {guestRatingShort}
        </div>
    );
};
